var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"community-market-trend-page"},[_vm._v("Community Market Trend")])}
var staticRenderFns = []

export { render, staticRenderFns }